export default __webpack_public_path__ + "static/user6-b1fc06f7ca08e23d69ea0a33f3bca155.jpeg";